// 1.导入axios
import axios from 'axios';
// import { useRouter } from 'vue-router';
// const router = useRouter();
// 直接引入路由实例
import router from '../router';
// 2.创建axios副本
const axiosAPI = axios.create({
  baseURL: process.env.VUE_APP_LocalRootUrl,
});
// 3.请求拦截器
axiosAPI.interceptors.request.use(
  (config) => {
    let getToken = localStorage.getItem('ssptoken');
    if (getToken) {
      config.headers.Authorization = 'Bearer ' + getToken;
    }
    return config;
  },
  (error) => {
    console.log(error, '请求失败之后的结果');
    return Promise.reject(error);
  }
);
// 4.响应拦截器
axiosAPI.interceptors.response.use(
  (res) => {
    if (res.data.Success === false && res.data.ErrorCode === 401) {
      // 清除本地存储的 token
      localStorage.removeItem('ssptoken');
      // 跳转到登录页面
      // router.push({ name: 'Login' });
      router.push({ path: '/' });
    }
    return res.data;
  },
  (error) => {
    // return Promise.reject(error);
    return error, '响应失败的结果';
  }
);
// 5.暴露出去
export default axiosAPI;
